import { FigureVarData, isFigureVarData } from "./FigureVarData";

export interface FigureReferenceLinesData {
  id: string;
  properties: FigureVarData[];
}

/**
 * Type guard to check if an object is a FigureReferenceLinesData
 *
 * @param obj - The object to check
 * @returns True if the object is a FigureReferenceLinesData
 */
export const isFigureReferenceLinesData = (obj: unknown): obj is FigureReferenceLinesData => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureReferenceLinesData;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((prop) => !isFigureVarData(prop))) {
    return false;
  }
  return true;
};
